// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607030804/js/" + chunkId + "." + {"44":"e5f77350","225":"34edd9de","481":"dac227c1","486":"60a594b8","770":"c8a16a09"}[chunkId] + ".0.38950904212595694.chunk.js";
};